export default __webpack_public_path__ + "static/media/security-manager-up.764d13b1.png";